<template>
    <span :class="`label label-${color}`" :title="title">
        <slot></slot>
    </span>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            required: false,
            default: 'default',
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
    },
}
</script>